import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getUsuarios({ commit }) {
      try {
        const response = await api.get('/usuarios')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getUsuariosGestores({ commit }) {
      try {
        const response = await api.get('/usuarios/gestores')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
